import React, { useEffect, useState, useMemo } from "react";
import Carousel from "../components/Carousel";
import ImageScrollGallery from "../components/ImageScrollGallery";
import JournalCard from "../components/JournalCard";
import ArticleCard from "../components/ArticleCard";
import { Row, Col } from "react-bootstrap";

const HomePage = () => {
  const J1 = "current-molecular-pharmacology";
  const J2 = "current-pharmaceutical-analysis";
  const [articles, setArticles] = useState([]);
  const [journals, setJournals] = useState([]);
  // 显示更多核心状态：当前已加载条数（8条数据）
  const [loadedCount, setLoadedCount] = useState(8);
  const loadStep = 10;

  // 文章请求
  const fetchArticle = () => {
    const volumeNumbers = Array.from({ length: 7 }, (_, i) => i + 1);
    const newNumbers = Array.from({ length: 1 }, (_, i) => i + 1);

    const fetchNewPromises = newNumbers.map((number) =>
      fetch(`/json/volumes/${J1}-issue/volume_issue18_${number}.json`).then(
        (response) => {
          if (!response.ok) throw new Error(`Failed to load volume_issue18_${number}.json`);
          return response.json();
        }
      )
    );

    const fetchPromises = volumeNumbers.map((number) =>
      fetch(`/json/volumes/${J2}-issue/volume_issue21_${number}.json`).then(
        (response) => {
          if (!response.ok) throw new Error(`Failed to load volume_issue21_${number}.json`);
          return response.json();
        }
      )
    );

    Promise.all([...fetchPromises, ...fetchNewPromises])
      .then((results) => {
        const allArticles = results.flat();
        setArticles(allArticles.reverse());
      })
      .catch((error) => console.error("Error loading volume data:", error));
  };

  // 侧边栏
  const fetchSidebar = () => {
    const fetch1 = fetch("/json/volumes/volumes/current-molecular-pharmacology-volume.json").then((res) => res.json());
    const fetch2 = fetch("/json/volumes/volumes/current-pharmaceutical-analysis-volume.json").then((res) => res.json());

    Promise.all([fetch1, fetch2])
      .then(([data1, data2]) => {
        const list1 = data1.volumes[0].issues.sort((a, b) => b.id - a.id).map(item => ({ ...item, tab: 18, name: "Current Molecular Pharmacology" }));
        const list2 = data2.volumes[0].issues.sort((a, b) => b.id - a.id).map(item => ({ ...item, tab: 21, name: "Current Pharmaceutical Analysis" }));
        const mergedList = [...list1, ...list2].slice(0, 10);
        setJournals(mergedList);
      })
      .catch((error) => console.error("Error loading volume data:", error));
  };

  useEffect(() => {
    fetchArticle();
    fetchSidebar();
  }, []);

  // 计算当前应显示的文章（从0到loadedCount）
  const displayedArticles = useMemo(() => {
    return articles.slice(0, loadedCount);
  }, [articles, loadedCount]);

  const handleShowMore = () => {
    if (loadedCount < articles.length) {
      setLoadedCount(prev => Math.min(prev + loadStep, articles.length));
    }
  };

  return (
    <div>
      <div className="flex d-flex">
        <Row className="m-0" style={{ width: "100%" }}>
          <Col md={12} xs={12}>
            <Carousel />
            <div>
              <section className="articles-header mb-20">
                <h2 style={{ fontSize: "1.5rem" }}>Explore Our Journals</h2>
              </section>
              <ImageScrollGallery />
            </div>

            {/* 文章列表 + 显示更多按钮 */}
            <div className="fade-in-up">
              <section className="articles-header mb-20">
                <h2 style={{ fontSize: "1.5rem" }}>Relevant Literature</h2>
              </section>
              <section className="articles-section">
                <Row className="m-0 p-0" style={{ width: "100%" }}>
                  {/* 渲染当前已加载的文章 */}
                  {displayedArticles.map((article, index) => (
                    <Col key={index} md={12} xs={12} className="p-2">
                      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                        <ArticleCard article={article} style={{ flexGrow: 1 }} />
                      </div>
                    </Col>
                  ))}
                  {/* 无数据提示 */}
                  {displayedArticles.length === 0 && (
                    <div style={{ width: "100%", textAlign: "center", padding: "20px" }}>
                      No articles found
                    </div>
                  )}
                </Row>

                {/* 显示更多按钮：仅当还有未加载的文章时显示 */}
                {loadedCount < articles.length && (
                  <div style={{ 
                    display: "flex", 
                    justifyContent: "center", 
                    marginBottom: "20px" 
                  }}>
                    <button
                      onClick={handleShowMore}
                      style={{
                        padding: "8px 20px",
                        border: "1px solid #000000",
                        borderRadius: "4px",
                        backgroundColor: "#000000",
                        color: "white",
                        cursor: "pointer",
                        transition: "all 0.3s ease"
                      }}
                    >
                      Show more results
                    </button>
                  </div>
                )}
              </section>
            </div>
          </Col>
          {/* <Col md={3} xs={12}>
            <aside className="mb-2">
              <div style={{ display: "flex", flexDirection: "column" }}>
                {journals.map((journal, index) => (
                  <JournalCard key={index} journal={journal} />
                ))}
                {journals.length === 0 && "No data"}
              </div>
            </aside>
          </Col> */}
        </Row>
      </div>
    </div>
  );
};

export default HomePage;